import * as utils from "../utils/utils";
import config from "../config";
import useBrandTranslation from "../hooks/useBrandTranslation";

export default function ConfirmEmail({ email, onBackToLogin }) {
  const { t } = useBrandTranslation();
  const message = t(
    "auth.confirmEmailNoLongerRequired",
    "La confirmación por email ya no es necesaria. Puedes iniciar sesión con tus credenciales."
  );
  const error = "";

  const handleBackToLogin = () => {
    if (onBackToLogin) {
      onBackToLogin();
    } else {
      window.location.href = "/login";
    }
  };

  return (
    <div className="flex flex-col w-screen h-screen bg-cold-white">
      <div className="flex h-[calc(100vh-4rem)]">
        <main className="flex-1">
          <div className="h-full overflow-auto mt-4">
            <div className="flex flex-col items-center justify-center h-full mb-4">
              <div className="flex items-center justify-center mb-4">
                <img
                  src={utils.getBrandLogo() || "/placeholder.svg"}
                  alt="logo"
                  className="w-12 h-12 object-cover"
                />
                <h1 className="inline-block text-2xl sm:text-3xl text-gray-400 pl-2 tracking-tight">
                  {config.brand}
                </h1>
              </div>

              <div className="flex flex-col items-center justify-center p-6 rounded-lg w-[100%] max-w-[500px] shadow-lg border border-gray-100 bg-white">
                {/* Icono de email */}
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg
                    className="w-8 h-8 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>

                <header className="mb-6 text-center">
                  <h1 className="mb-2 text-2xl font-bold text-gray-900">
                    {t("auth.confirmEmailTitle", "Confirma tu email")}
                  </h1>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {t("auth.confirmEmailSent", "Te hemos enviado un email de confirmación a:")}
                  </p>
                  {email && (
                    <p className="text-sm font-medium text-gray-900 mt-1">
                      {email}
                    </p>
                  )}
                  <p className="text-sm text-gray-600 mt-3 leading-relaxed">
                    {t(
                      "auth.confirmEmailHint",
                      "Haz clic en el enlace del email para activar tu cuenta y poder iniciar sesión."
                    )}
                  </p>
                </header>

                <div className="w-full flex flex-col space-y-3">
                  {/* <Button
                    onClick={handleResendConfirmation}
                    disabled={isResending}
                    variant="outline"
                    className="w-full"
                  >
                    {isResending
                      ? "Reenviando..."
                      : "Reenviar email de confirmación"}
                  </Button> */}

                  <button
                    onClick={handleBackToLogin}
                    className="text-gray-900 underline text-center py-2"
                  >
                    {t("auth.backToLogin", "Volver al inicio de sesión")}
                  </button>

                  {message && (
                    <div className="p-3 bg-green-50 border border-green-200 rounded-md">
                      <p className="text-sm text-green-800">{message}</p>
                    </div>
                  )}

                  {error && (
                    <div className="p-3 bg-red-50 border border-red-200 rounded-md">
                      <p className="text-sm text-red-800">{error}</p>
                    </div>
                  )}
                </div>

                <div className="mt-6 p-4 bg-gray-50 rounded-md w-full">
                  <p className="text-xs text-gray-600 text-center">
                    <strong>{t("auth.confirmEmailNoReceived", "¿No recibiste el email?")}</strong>
                    <br />
                    {t("auth.confirmEmailCheckSpam", "Revisa tu carpeta de spam o correo no deseado.")}
                    <br />
                    {t("auth.confirmEmailContactSupport", "Si sigues teniendo problemas, contacta con soporte.")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
